import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function FreeTrialSection() {
  const navigate = useNavigate();

  return (
    <div
      style={{ backgroundImage: `url('/freetrial.jpg')`, backgroundAttachment: 'fixed' }}
      className="relative flex w-full flex-wrap items-center justify-center gap-[4rem] bg-cover bg-[0px_70%] bg-no-repeat px-[2rem] py-[10rem] font-inter"
    >
      {/* Overlay */}
      <div className="absolute left-0 top-0 z-[0] h-full w-full bg-[#00142C] opacity-[0.7]"></div>

      {/* Animated Content */}
      <motion.div
        className="z-[111] flex w-full flex-wrap items-center justify-center gap-[4rem]"
        initial={{ opacity: 0, y: 50 }} // start slightly below
        whileInView={{ opacity: 1, y: 0 }} // move to original position
        viewport={{ once: true, amount: 0.5 }} // trigger when 50% visible
        transition={{ duration: 1, ease: 'linear' }} // linear movement
      >
        <h1 className="w-full text-center text-[3.6rem] font-[600] leading-[4.6rem] text-white">
          Still Confused About Our Services? Get In Touch With Us
        </h1>
        <p className="w-full max-w-[80rem] text-center text-[1.6rem] leading-[2.6rem] text-[#FFFFFF]">
          You can contact us any way that is convenient for you.
          <br />
          We are available 24/7 via email or telephone.
        </p>
        <div className="z-[5555] flex w-full flex-row flex-wrap justify-center gap-[4rem]">
          <div
            onClick={() => navigate('/contact-us')}
            className="flex h-[5.4rem] w-[17.10rem] cursor-pointer flex-row flex-wrap items-center justify-center gap-[1rem] rounded-[0.6rem] bg-[#0EC9AC] text-[1.6rem] font-[600] text-[#F9FEFF]"
          >
            CONTACT US
          </div>
        </div>
      </motion.div>
    </div>
  );
}
